import { Env, MultiClient } from "config"
import { CLIENTS_AUTH0, INTERNAL_AUTH0 } from "constants/AUTH0_CONSTANTS"
import { CLIENT, ENV } from "config/init"
import { useInternalAuthStore } from "store/internalAuthStore"

interface IAuth0Credentials {
  clientId: string
  audience: string
  domain: string
}

const useAuth0Credentials = (): IAuth0Credentials => {
  const { isInternalMode } = useInternalAuthStore()
  const [_client, _env] = MultiClient.get_user_env(null, Env.clients, Env.env, Env.defaults)
  const _href = window.location.href

  // If internal mode is active and internal credentials are configured, use them
  if (isInternalMode && INTERNAL_AUTH0.clientId && INTERNAL_AUTH0.domain && INTERNAL_AUTH0.audience) {
    return {
      clientId: INTERNAL_AUTH0.clientId,
      audience: INTERNAL_AUTH0.audience,
      domain: INTERNAL_AUTH0.domain,
    }
  }

  const credentials = {
    clientId: CLIENTS_AUTH0[_client]?.[_env].clientId || "",
    audience: CLIENTS_AUTH0[_client]?.[_env].audience || "",
    domain: CLIENTS_AUTH0[_client]?.[_env].domain || "",
  }

  if (_href.includes("entelpe-xmonitor")) {
    return {
      clientId: CLIENTS_AUTH0[CLIENT.ENTEL_PERU][ENV.PROD].clientId || "",
      audience: CLIENTS_AUTH0[CLIENT.ENTEL_PERU][ENV.PROD].audience || "",
      domain: CLIENTS_AUTH0[CLIENT.ENTEL_PERU][ENV.PROD].domain || "",
    }
  }

  return { ...credentials }
}

export default useAuth0Credentials
